import React from 'react';
import { StyledIframe, StyledWrapper } from './styled';
import Seo from '../../components/Seo';
import { PAGE_SEO } from '../../service/seoMeta';

const PrivacyPage = () => (
  <StyledWrapper>
    <Seo {...PAGE_SEO.privacy} />
    <StyledIframe
      title="Privacy"
      src="https://app.termly.io/policy-viewer/policy.html?policyUUID=fcd7dca9-9b79-496c-9370-103a2bd03b61"
    />
  </StyledWrapper>
);

export default PrivacyPage;
